import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import {user, putUser, resetUser, getUserCorporates} from '../../../api/userApi'

export default function* userEditSaga() {
  yield all([
    fork(watchFetchUserEditRequest),
    fork(watchUpdateUserEditRequest),
    fork(watchEditUserIdBankFieldChangeRequest),
    fork(watchEditUserCorporateSenderIdFieldChangeRequest),
    fork(watchEditUserCorporatePermissionChangeRequest),
    fork(watchEditUserFullNameFieldChangeRequest),
    fork(watchEditUserDescriptionFieldChangeRequest),
    fork(watchEditUserEnabledFieldChangeRequest),
    fork(watchEditUserUsernameFieldChangeRequest),
    fork(watchEditUserPhoneFieldChangeRequest),
    fork(watchEditUserEmailFieldChangeRequest),
    fork(watchEditUserResetFieldChangeRequest),
    fork(watchEditPasswordResetFieldChangeRequest),
    fork(watchEditUserRoleFieldChangeRequest),
    fork(watchEditUserLanguageFieldChangeRequest),
    fork(watchUserPasswordReset),
    fork(watchFetchUserCorporatesRequest),
    // fork(watchEditUserCorporatePermissionListUpdate),
    fork(watchEditUserCleanRequest)
  ]);
}

function* watchFetchUserCorporatesRequest() {
  yield takeLatest(
      actions.FETCH_USER_CORPORATES_REQUEST,
      fetchUserCorporatesRequest
  )
}

function* fetchUserCorporatesRequest(role){
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(getUserCorporates, role.value.idBank,role.value.role)
    yield put({ type: actions.FETCH_USER_CORPORATES_SUCCESS, value: {allCorporates:data,corporates:role.value.corporates} })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_USER_CORPORATES_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }

  }
}
function* watchFetchUserEditRequest() {
  yield takeLatest(
      actions.FETCH_USER_EDIT_REQUEST,
      fetchUserEditRequest
  )
}

function* fetchUserEditRequest(userData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(user, userData.value)
    yield put({ type: actions.FETCH_USER_EDIT_SUCCESS, value: data })
    yield put(push(`/user/edit/${userData.value}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_USER_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }

  }
}

function* watchUserPasswordReset() {
  yield takeLatest(
      actions.USER_DETAIL_RESET_REQUEST,
      userPasswordReset
  )
}

function* userPasswordReset(userData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(resetUser, userData.value)
    yield put({ type: actions.USER_DETAIL_RESET_SUCCESS, value: data })
    yield put(push(`/user/`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.USER_DETAIL_RESET_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}


function* watchUpdateUserEditRequest() {
  yield takeLatest(
      actions.UPDATE_USER_EDIT_REQUEST,
      updateUserRequestEdit
  )
}

function* updateUserRequestEdit(user) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(putUser, user.value)
    yield put({ type: actions.UPDATE_USER_EDIT_SUCCESS, value: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.EDIT_USER_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.UPDATE_USER_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })

    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }

  }
}

// function* watchEditUserCorporatePermissionListUpdate() {
//   yield takeLatest(
//       actions.EDIT_USER_CORPORATE_PERMISSION_LIST_REQUEST,
//       editUserCorporatePermissionListUpdate
//   )
// }
//
//
// function checkUserCorporate(senderId,allUserCorporates){
//   let response=false;
//   if(undefined !== allUserCorporates){
//     allUserCorporates.map((item)=>{
//       if(item===senderId){
//         response=true;
//       }
//     })
//   }
//   return response;
// }
//
// function* editUserCorporatePermissionListUpdate(corporateList) {
//
//   // getCorporatePermissionList=()=>{
//     var permissionList=[];
//
//   corporateList.value.corporates.map((item)=>{
//       // if(this.props.userCorporates.length>0){
//       if(checkUserCorporate(item.corporateSenderId,corporateList.value.allUserCorporates) === true){
//         var corporate={
//           corporateSenderName:item.corporateSenderName,
//           corporateSenderId:item.corporateSenderId,
//           read:false,
//           write:false
//         }
//         permissionList.push(corporate)
//       }
//       // }
//     })
//     let finalList=[];
//     if(corporateList.value.userCorporates.length>0){
//       // permissionList=permissionList.
//       corporateList.value.userCorporates.map((userCorp)=>{
//         finalList=permissionList.map((corporatePerm)=>{
//           if(corporatePerm.corporateSenderId===userCorp.corporateSenderId){
//             corporatePerm.read=userCorp.read;
//             corporatePerm.write=userCorp.write;
//             // finalList.push(corporatePerm);
//             return corporatePerm
//
//           }else{
//
//             // finalList.push(corporatePerm);
//             return corporatePerm
//           }
//         })
//       })
//     }else{
//
//       finalList=permissionList;
//
//     }
//
//     // this.props.permissionListUpdate(finalList)
//     // return permissionList;
//   // }
//   yield put({ type: actions.EDIT_USER_CORPORATE_PERMISSION_LIST, value: finalList })
// }

function* watchEditUserCorporatePermissionChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_CORPORATE_PERMISSION_CHANGE_REQUEST,
      editUserCorporatePermissionChangeRequest
  )
}

function* editUserCorporatePermissionChangeRequest(corporateList) {
  yield put({ type: actions.EDIT_USER_CORPORATE_PERMISSION_CHANGE, value: corporateList.value })
}

function* watchEditUserFullNameFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_FULL_NAME_FIELD_CHANGE_REQUEST,
      editUserFullNameFieldChangeRequest
  )
}

function* editUserFullNameFieldChangeRequest(fullName) {
  yield put({ type: actions.EDIT_USER_FULL_NAME_FIELD_CHANGE, value: fullName.value })
}

function* watchEditUserDescriptionFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_DESCRIPTION_FIELD_CHANGE_REQUEST,
      editUserDescriptionFieldChangeRequest
  )
}

function* editUserDescriptionFieldChangeRequest(description) {
  yield put({ type: actions.EDIT_USER_DESCRIPTION_FIELD_CHANGE, value: description.value })
}

function* watchEditUserEnabledFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_ENABLED_FIELD_CHANGE_REQUEST,
      editUserEnabledFieldChangeRequest
  )
}

function* editUserEnabledFieldChangeRequest(enabled) {
  yield put({ type: actions.EDIT_USER_ENABLED_FIELD_CHANGE, value: enabled.value })
}

function* watchEditUserUsernameFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_USERNAME_FIELD_CHANGE_REQUEST,
      editUserUsernameFieldChangeRequest
  )
}

function* watchEditUserLanguageFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_USER_LANGUAGE_FIELD_CHANGE_REQUEST,
    editUserLanguageFieldChangeRequest
  )
}

function* editUserLanguageFieldChangeRequest(language) {
  yield put({ type: actions.EDIT_USER_LANGUAGE_FIELD_CHANGE, value: language.value })
}

function* editUserUsernameFieldChangeRequest(username) {
  yield put({ type: actions.EDIT_USER_USERNAME_FIELD_CHANGE, value: username.value })
}

function* watchEditUserPhoneFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_PHONE_FIELD_CHANGE_REQUEST,
      editUserPhoneFieldChangeRequest
  )
}

function* editUserPhoneFieldChangeRequest(phone) {
  yield put({ type: actions.EDIT_USER_PHONE_FIELD_CHANGE, value: phone.value })
}

function* watchEditUserEmailFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_EMAIL_FIELD_CHANGE_REQUEST,
      editUserEmailFieldChangeRequest
  )
}

function* editUserEmailFieldChangeRequest(email) {
  yield put({ type: actions.EDIT_USER_EMAIL_FIELD_CHANGE, value: email.value })
}

function* watchEditUserResetFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_RESET_FIELD_CHANGE_REQUEST,
      editUserResetFieldChangeRequest
  )
}

function* editUserResetFieldChangeRequest(reset) {
  yield put({ type: actions.EDIT_USER_RESET_FIELD_CHANGE, value: reset.value })
}

function* watchEditPasswordResetFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_PASSWORD_FIELD_CHANGE_REQUEST,
      editUserPasswordFieldChangeRequest
  )
}

function* editUserPasswordFieldChangeRequest(reset) {
  yield put({ type: actions.EDIT_USER_PASSWORD_FIELD_CHANGE, value: reset.value })
}

function* watchEditUserRoleFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_ROLE_FIELD_CHANGE_REQUEST,
      editUserRoleFieldChangeRequest
  )
}

function* editUserRoleFieldChangeRequest(role) {
  yield put({ type: actions.EDIT_USER_ROLE_FIELD_CHANGE, value: role.value })
}

function* watchEditUserIdBankFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_ID_BANK_FIELD_CHANGE_REQUEST,
      editUserIdBankFieldChangeRequest
  )
}

function* editUserIdBankFieldChangeRequest(idBank) {
  if(idBank.value !== null)
    yield put({type: actions.EDIT_USER_ID_BANK_FIELD_CHANGE, value: idBank.value})
  else
    yield put({type: actions.EDIT_USER_ID_BANK_FIELD_CHANGE, value: ''})
}

function* watchEditUserCorporateSenderIdFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST,
      editUserCorporateSenderIdFieldChangeRequest
  )
}

function* editUserCorporateSenderIdFieldChangeRequest(corporateSenderId) {
  if(corporateSenderId.value !== null)
    yield put({type: actions.EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE, value: corporateSenderId.value})
  else
    yield put({type: actions.EDIT_USER_CORPORATE_SENDER_ID_FIELD_CHANGE, value: ''})
}

function* watchEditUserCleanRequest() {
  yield takeLatest(
      actions.EDIT_USER_CLEAN_REQUEST,
      editUserCleanRequest
  )
}

function* editUserCleanRequest() {
  yield put({ type: actions.EDIT_USER_CLEAN })
}